import { graphql } from "@/lib/gql/__generated__";

export const basicCustomMailSettingI18n = graphql(/* GraphQL */ `
	query BasicCustomMailSettingI18n($hotelID: ID!, $langCode: LangCode!) {
		basicCustomMailSettingI18n(hotelID: $hotelID, lang: $langCode) {
			id
			forReservation {
				atCreated {
					text
				}
				atUpdated {
					text
				}
				atCanceled {
					text
				}
				atCheckInBefore_07days {
					text
					shouldSendEmail
				}
				atCheckInBefore_01days {
					text
					shouldSendEmail
				}
				atCheckInBefore_00days {
					text
					shouldSendEmail
				}
				atCheckOutAfter_01days {
					text
					shouldSendEmail
				}
				atRequest {
					text
				}
				atConfirmed {
					text
				}
				atDeclined {
					text
				}
			}
			forShopping {
				atCreated {
					text
				}
			}
			mailFooterExternalLink
		}
	}
`);
